import { userService } from "../api/user-auth";

const state = {
    plant_botanys: [],
    new_plant_botany: null,
    pot_sizes: [],
    new_pot_size: null,
    pot_setups: [],
    new_pot_setup: null,
    toppings: [],
    new_topping: null,
    pot_internals: [],
    new_pot_internal: null,
};

const getters = {
    // eslint-disable-next-line no-unused-vars
    plant_botanys: (state, getters) => {
        return state.plant_botanys;
    },
    // eslint-disable-next-line no-unused-vars
    pot_sizes: (state, getters) => {
        return state.pot_size;
    },
    // eslint-disable-next-line no-unused-vars
    pot_setups: (state, getters) => {
        return state.pot_setups;
    },
    // eslint-disable-next-line no-unused-vars
    toppings: (state, getters) => {
        return state.toppings;
    },
    // eslint-disable-next-line no-unused-vars
    pot_internals: (state, getters) => {
        return state.pot_internals;
    },
};

const actions = {
    loadPlantBotanys({ commit }, plant_botanys) {
        commit("loadPlantBotanys", plant_botanys);
    },
    getPlantBotanys({ dispatch, commit }) {
        userService.getJson("plant_variety/list").then(
            response => {
                if (response.ok) {
                    commit("loadPlantBotanys", response.data);
                } else {
                    commit("clear");
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                commit("clear");
                dispatch("alert/error", error, { root: true });
            },
        );
    },
    apiSavePlantBotany({ dispatch, commit }, plant_botany) {
        userService.post("plant_variety/" + plant_botany.id, plant_botany).then(
            response => {
                if (response.ok) {
                    commit("updatePlantBotany", response.data);
                } else {
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                dispatch("alert/error", error, { root: true });
            },
        );
    },
    apiCreatePlantBotany({ dispatch, commit }, plant_botany) {  // plant_botany = data 
        userService.post("plant_variety/" + plant_botany.id, plant_botany).then(
            response => {
                if (response.ok) {
                    commit("addPlantBotany", response.data);
                } else {
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                dispatch("alert/error", error, { root: true });
            },
        );
    },

//------------------| Toppings |-------------------------
    loadToppings({ commit }, toppings) {
        commit("loadToppings", toppings);
    },
    getToppings({ dispatch, commit }) {
        userService.getJson("topping/list").then(
            response => {
                if (response.ok) {
                    commit("loadToppings", response.data);
                } else {
                    commit("clear");
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                commit("clear");
                dispatch("alert/error", error, { root: true });
            },
        );
    },
    apiSaveTopping({ dispatch, commit }, topping) {
        userService.post("topping/" + topping.id, topping).then(
            response => {
                if (response.ok) {
                    commit("updateTopping", response.data);
                } else {
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                dispatch("alert/error", error, { root: true });
            },
        );
    },
    apiCreateTopping({ dispatch, commit }, topping) {  // topping = data 
        userService.post("topping/" + topping.id, topping).then(
            response => {
                if (response.ok) {
                    commit("addTopping", response.data);
                } else {
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                dispatch("alert/error", error, { root: true });
            },
        );
    },

    //TODO //------------------| POTS |-------------------------

    //------------------| POT SIZE |-------------------------
    loadPotSizes({ commit }, potsizes) {
        commit("loadPotSizes", potsizes);
    },
    getPotSizes({ dispatch, commit }) {
        userService.getJson("potsize/list").then(
            response => {
                if (response.ok) {
                    commit("loadPotSizes", response.data);
                } else {
                    commit("clear");
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                commit("clear");
                dispatch("alert/error", error, { root: true });
            },
        );
    },
    apiSavePotSize({ dispatch, commit }, potsize) {
        userService.post("potsize/" + potsize.id, potsize).then(
            response => {
                if (response.ok) {
                    commit("updatePotSize", response.data);
                } else {
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                dispatch("alert/error", error, { root: true });
            },
        );
    },
    apiCreatePotSize({ dispatch, commit }, potsize) {  // potsize = data 
        userService.post("potsize/" + potsize.id, potsize).then(
            response => {
                if (response.ok) {
                    commit("addPotSize", response.data);
                } else {
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                dispatch("alert/error", error, { root: true });
            },
        );
    },

    //------------------| POT SETUP |-------------------------
    loadPotSetups({ commit }, potsetups) {
        commit("loadPotSetups", potsetups);
    },
    getPotSetups({ dispatch, commit }) {
        userService.getJson("potsetup/list").then(
            response => {
                if (response.ok) {
                    commit("loadPotSetups", response.data);
                } else {
                    commit("clear");
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                commit("clear");
                dispatch("alert/error", error, { root: true });
            },
        );
    },
    apiSavePotSetup({ dispatch, commit }, potsetup) {
        userService.post("potsetup/" + potsetup.id, potsetup).then(
            response => {
                if (response.ok) {
                    commit("updatePotSetup", response.data);
                } else {
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                dispatch("alert/error", error, { root: true });
            },
        );
    },
    apiCreatePotSetup({ dispatch, commit }, potsetup) {  // potsetup = data 
        userService.post("potsetup/" + potsetup.id, potsetup).then(
            response => {
                if (response.ok) {
                    commit("addPotSetup", response.data);
                } else {
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                dispatch("alert/error", error, { root: true });
            },
        );
    },

    //------------------| POT INTERNALS |-------------------------
    loadPotInternals({ commit }, potinternals) {
        commit("loadPotInternals", potinternals);
    },
    getPotInternals({ dispatch, commit }) {
        userService.getJson("potinternal/list").then(
            response => {
                if (response.ok) {
                    commit("loadPotInternals", response.data);
                } else {
                    commit("clear");
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                commit("clear");
                dispatch("alert/error", error, { root: true });
            },
        );
    },
    apiSavePotInternal({ dispatch, commit }, potinternal) {
        userService.post("potinternal/" + potinternal.id, potinternal).then(
            response => {
                if (response.ok) {
                    commit("updatePotInternal", response.data);
                } else {
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                dispatch("alert/error", error, { root: true });
            },
        );
    },
    apiCreatePotInternal({ dispatch, commit }, potinternal) {  // potinternal = data 
        userService.post("potinternal/" + potinternal.id, potinternal).then(
            response => {
                if (response.ok) {
                    commit("addPotInternal", response.data);
                } else {
                    dispatch("alert/error", response.message, { root: true });
                }
            },
            error => {
                dispatch("alert/error", error, { root: true });
            },
        );
    },
};

const mutations = {
    // Plant Variety
    addPlantBotany(state, plant_botany) {
        state.plant_botanys.push(plant_botany);
        state.new_plant_botany = plant_botany;
    },
    updatePlantBotany(state, plant_botany) {
        var index = state.plant_botanys.findIndex(v => v.id == plant_botany.id);
        state.plant_botanys[index] = plant_botany;
    },
    loadPlantBotanys(state, plant_botanys) {
        state.plant_botanys = plant_botanys;
    },
    clearPlantBotany(state) {
        state.plant_botanys = [];
    },

    // TODO - Pots : change "Pots" states
    addPots(state, plant_botany) {
        state.plant_botanys.push(plant_botany);
        state.new_plant_botany = plant_botany;
    },
    updatePots(state, plant_botany) {
        var index = state.plant_botanys.findIndex(v => v.id == plant_botany.id);
        state.plant_botanys[index] = plant_botany;
    },
    loadPots(state, plant_botanys) {
        state.plant_botanys = plant_botanys;
    },
    clearPots(state) {
        state.plant_botanys = [];
    },

    // Topping
    addTopping(state, topping) {
        state.toppings.push(topping);
        state.new_topping = topping;
    },
    updateTopping(state, topping) {
        var index = state.toppings.findIndex(v => v.id == topping.id);
        state.toppings[index] = topping;
    },
    loadToppings(state, toppings) {
        state.toppings = toppings;
    },
    clearTopping(state) {
        state.toppings = [];
    },

    // Pot size 
    addPotSize(state, potsize) {
        state.pot_sizes.push(potsize);
        state.new_potsize = potsize;
    },
    updatePotSize(state, potsize) {
        var index = state.potsizes.findIndex(v => v.id == potsize.id);
        state.pot_sizes[index] = potsize;
    },
    loadPotSizes(state, potsizes) {
        state.pot_sizes = potsizes;
    },
    clearPotSize(state) {
        state.pot_sizes = [];
    },

    // Pot setup 
    addPotSetup(state, potsetup) {
        state.pot_setups.push(potsetup);
        state.new_potsetup = potsetup;
    },
    updatePotSetup(state, potsetup) {
        var index = state.pot_setups.findIndex(v => v.id == potsetup.id);
        state.pot_setups[index] = potsetup;
    },
    loadPotSetups(state, potsetups) {
        state.pot_setups = potsetups;
    },
    clearPotSetup(state) {
        state.pot_setups = [];
    },

    // Pot internal
    addPotInternal(state, potinternal) {
        state.pot_internals.push(potinternal);
        state.new_potinternal = potinternal;
      },
      updatePotInternal(state, potinternal) {
        var index = state.potinternals.findIndex(v => v.id == potinternal.id);
        state.pot_internals[index] = potinternal;
      },
      loadPotInternals(state, potinternals) {
        state.pot_internals = potinternals;
      },
      clearPotInternal(state) {
        state.pot_internals = [];
      },
};

export const inventory = {
    namespaced: true,
    getters,
    state,
    actions,
    mutations,
};
